const META_DESCRIPTION_MAX_LENGTH = 160

export const stripHtml = (html: string): string =>
  html
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

export const formatMetaDescription = (
  text: string | undefined,
): string | undefined => {
  if (!text) {
    return undefined
  }
  const plain = stripHtml(text).trim()
  if (!plain) {
    return undefined
  }
  if (plain.length <= META_DESCRIPTION_MAX_LENGTH) {
    return plain
  }
  return `${plain.slice(0, META_DESCRIPTION_MAX_LENGTH - 1).trimEnd()}…`
}
